module.exports = __webpack_public_path__ + "static/scale-model-of-odessa-convention-&-visitors-bureau-in-odessa-texas-0eacf3df67d95c0a79663199862ac3d6.png";